import { ElementRef } from '@angular/core';

import { QuestionHidden, type IQuestionHidden } from './question-hidden';

export interface IQuestionCollapseKpi extends IQuestionHidden<string> {
  tooltip?: {
    type: 'text' | 'template';
    text?: string;
    template?: ElementRef;
  };
}

export class QuestionCollapseKpi
  extends QuestionHidden<string>
  implements IQuestionCollapseKpi
{
  public tooltip: {
    type: 'text' | 'template';
    text?: string;
    template?: ElementRef;
  };

  constructor(options: IQuestionCollapseKpi) {
    super(options);
    this.elementType = 'collapsekpi';
    this.tooltip = options.tooltip;
    this.size = 0;
  }

  public override update(emitEvent: boolean = false): void {
    this._formControl.updateValueAndValidity({ emitEvent, onlySelf: true });
  }
}
